// JavaScript Document
$(window).load(function(){

    /* Header */
    $(".global-header-sub--pd").hover(function() {
        var hei = $(this).find(".global-header-sub-box").outerHeight();
        $(this).find(".global-header-sub-inn").css({
            height: hei + "px"
        })
    }, function() {
        $(this).find(".global-header-sub-inn").css({
            height: 0
        })
    });
    $(".global-header-btn").click(function(){
        if($("body").hasClass("open-menu")){
            $("body").removeClass("open-menu");
        }else{
            $("body").addClass("open-menu");
        }
    });
  
    setInview();
    setRiseup();
    setPd();

    /*  フェードイン処理オフ  */
    setCover();
    actRiseup();
    $("#navSub, #footerNavSub, #navCart, #footerNavCart").addClass("active");
    /*  フェードイン処理オフ  */
  
	(function(d) {
    var config = {
      kitId: 'kjf5ghi',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);

    /*  フェードイン処理オフ  */
    /*
	setTimeout(function() {
        $("body").animate(
          {opacity:1},
          1000,
          function () {
            setCover();
            actRiseup();
          }
        );
		$("#navSub, #footerNavSub, #navCart, #footerNavCart").addClass("active");
	}, 800);
    */
    /*  フェードイン処理オフ  */

	//image undrag
	//$('img').mousedown(
    //    function(e){
    //      e.preventDefault();
    //    }
    //  );
    //  $('img').mouseup(
    //    function(e){
    //      e.preventDefault();
    //    }
    //  );
    //  $('img').on('contextmenu',function(){
    //    return false;
    //  });

	$(window).scroll(function(){

		$(".fade_off").each(function() {
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight / 5) {
				$(this).addClass("fade_on");
			} else {
				//$(this).removeClass("fade_on");
			}
		});

	});

	$("#modal ul").scroll(function() {

		$("#modal div").each(function() {
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight / 5) {
				$(this).addClass("fade_on");
			} else {
				//$(this).removeClass("fade_on");
			}
		});

	});

  //$("#navHykeSub ul:nth-child(3)").hide();
  
	//Parent
	$('body').highlight("(");
	$('body').highlight(")");

	if ($('body').hasClass('hyke')) {      
		$("#navHykeSub, #footerNavHykeSub").addClass("active");
	}
  
    if ($('body').hasClass('three')) {
		$("#navThreeSub, #footerNavThreeSub").addClass("active");
	}

	if ($('body').hasClass('online')) {
		$("#navOnlineSub, #footerNavOnlineSub").addClass("active");
	}
  
    if ($('body').hasClass('ss25')) {
		$("#navHykeSub ul:nth-child(2)").show();
		$("#navHykeSub ul:nth-child(3), #navHykeSub ul:nth-child(4), #navHykeSub ul:nth-child(5)").hide();
	}
  
    if ($('body').hasClass('fw24')) {
		$("#navHykeSub ul:nth-child(3)").show();
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(4), #navHykeSub ul:nth-child(5)").hide();
	}
  
    if ($('body').hasClass('ss24')) {
		$("#navHykeSub ul:nth-child(4)").show();
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(5)").hide();
	}
  
    if ($('body').hasClass('fw23')) {
		$("#navHykeSub ul:nth-child(5)").show();
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(3), #navHykeSub ul:nth-child(4)").hide();
	}
  
    if ($('body').hasClass('ss23')) {
		$("#navHykeSub ul:nth-child(5)").show();
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(3), #navHykeSub ul:nth-child(4)").hide();
	}
  
    if ($('body').hasClass('ss21')) {
    $("#navHykeSub ul:nth-child(4)").show();
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(3)").hide();
	}
  
    if ($('body').hasClass('fw20')) {
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(3)").hide();
	}


  /*20120414 ここから*/
  
  /*
  $("#navHykeSub ul:first-child li:first-child").hover(function(){
		$("#navHykeSub ul:nth-child(3), #navHykeSub ul:nth-child(4)").fadeOut(function(){
		  $("#navHykeSub ul:nth-child(2)").fadeIn();
        });
	});
  
    $("#navHykeSub ul:first-child li:nth-child(2)").hover(function(){
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(4)").fadeOut(function(){
		  $("#navHykeSub ul:nth-child(3)").fadeIn();
        });
	});
  
    $("#navHykeSub ul:first-child li:last-child").hover(function(){
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(3)").fadeOut(function(){
		  $("#navHykeSub ul:nth-child(4)").fadeIn();
        });
	});
    */

	var hoverTimer;
	
	$("#navHykeSub ul:first-child li:first-child").hover(function(){
		clearTimeout(hoverTimer);		
		$("#navHykeSub ul:nth-child(3), #navHykeSub ul:nth-child(4), #navHykeSub ul:nth-child(5)").fadeOut(400);
		
		hoverTimer = setTimeout(function(){
			$("#navHykeSub ul:nth-child(2)").fadeIn();
		},400);
	});
	
	$("#navHykeSub ul:first-child li:nth-child(2)").hover(function(){
		clearTimeout(hoverTimer);
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(4), #navHykeSub ul:nth-child(5)").fadeOut(400);

		hoverTimer = setTimeout(function(){
			$("#navHykeSub ul:nth-child(3)").fadeIn();
		},400);
	});
  
    $("#navHykeSub ul:first-child li:nth-child(3)").hover(function(){
		clearTimeout(hoverTimer);
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(3), #navHykeSub ul:nth-child(5)").fadeOut(400);

		hoverTimer = setTimeout(function(){
			$("#navHykeSub ul:nth-child(4)").fadeIn();
		},400);
	});
  
	$("#navHykeSub ul:first-child li:nth-child(4)").hover(function(){
		clearTimeout(hoverTimer);
		$("#navHykeSub ul:nth-child(2), #navHykeSub ul:nth-child(3), #navHykeSub ul:nth-child(4)").fadeOut(400);

		hoverTimer = setTimeout(function(){
			$("#navHykeSub ul:nth-child(5)").fadeIn();
		},400);
	});
  
	if($("body").hasClass('hyke')){
        $("#navSpHykeInner").addClass("active").addClass("preActive");
	}

	/*20120414 ここまで*/

	//Header Nav
	$("#navHyke a").hover(function() {
		$("#navAHSub, #navThreeSub, #navOnlineSub").removeClass("active");
		$("#navHyke, #navThree, #navOnline").removeClass("hover");
		$("#navHykeSub").addClass("active");
		$("#navHyke").addClass("hover");
	});

	$("#navOnline a").hover(function() {
		$("#navHykeSub, #navThreeSub").removeClass("active");
		$("#navHyke, #navThree, #navOnline").removeClass("hover");
		$("#navOnlineSub").addClass("active");
		$("#navOnline").addClass("hover");
	});
  
	$("#navThree a").hover(function() {
		$("#navHykeSub, #navOnlineSub").removeClass("active");
		$("#navHyke, #navThree, #navOnline").removeClass("hover");
		$("#navThreeSub").addClass("active");
		$("#navThree").addClass("hover");
	});

	//footer Nav
	$("#footerNavHyke a").hover(function() {
		$("#footerNavAHSub, #footerNavThreeSub, #footerNavOnlineSub").removeClass("active");
		$("#footerNavHyke, #footerNavThree, #footerNavOnline").removeClass("hover");
		$("#footerNavHykeSub").addClass("active");
		$("#footerNavHyke").addClass("hover");
	});

	$("#footerNavOnline a").hover(function() {
		$("#footerNavHykeSub, #footerNavThreeSub").removeClass("active");
		$("#footerNavHyke, #footerNavThree, #footerNavOnline").removeClass("hover");
		$("#footerNavOnlineSub").addClass("active");
		$("#footerNavOnline").addClass("hover");
	});
  
  $("#footerNavThree a").hover(function() {
		$("#footerNavHykeSub, #footerNavOnlineSub").removeClass("active");
		$("#footerNavHyke, #footerNavThree, #footerNavOnline").removeClass("hover");
		$("#footerNavThreeSub").addClass("active");
		$("#footerNavThree").addClass("hover");
	});
  
  $("#footerNavHykeSub ul:first-child li:first-child").hover(function(){
		$("#footerNavHykeSub ul:nth-child(3), #footerNavHykeSub ul:nth-child(4), #footerNavHykeSub ul:nth-child(5)").fadeOut(function(){
		  $("#footerNavHykeSub ul:nth-child(2)").fadeIn();
    });
	});
  
  $("#footerNavHykeSub ul:first-child li:nth-child(2)").hover(function(){
		$("#footerNavHykeSub ul:nth-child(2), #footerNavHykeSub ul:nth-child(4), #footerNavHykeSub ul:nth-child(5)").fadeOut(function(){
		  $("#footerNavHykeSub ul:nth-child(3)").fadeIn();
    });
	});
  
  $("#footerNavHykeSub ul:first-child li:nth-child(3)").hover(function(){
		$("#footerNavHykeSub ul:nth-child(2), #footerNavHykeSub ul:nth-child(3), #footerNavHykeSub ul:nth-child(5)").fadeOut(function(){
		  $("#footerNavHykeSub ul:nth-child(4)").fadeIn();
    });
	});
  
  $("#footerNavHykeSub ul:first-child li:last-child").hover(function(){
		$("#footerNavHykeSub ul:nth-child(2), #footerNavHykeSub ul:nth-child(3), #footerNavHykeSub ul:nth-child(4)").fadeOut(function(){
		  $("#footerNavHykeSub ul:nth-child(5)").fadeIn();
    });
	});

	$("#navSubSearch").click(function() {
		setTimeout(function() {
			$("#searchMainTxt").focus();
		}, 100);
		$("#navSub, #navCart").removeClass("active");
		$("#searchInner, #searchLine").addClass("active");
	});

	$("#btnSearchClose").click(function() {
		$("#navSub, #navCart").addClass("active");
		$("#searchInner, #searchLine").removeClass("active");
	});

	$("#footerNavSubSearch").click(function() {
		setTimeout(function() {
			$("#footerearSearchMainTxt").focus();
		}, 100);
		$("#footerNavSub, #footerNavCart").removeClass("active");
		$("#footerSearchInner, #footerSearchLine").addClass("active");
	});

	$("#footerBtnSearchClose").click(function() {
		$("#footerNavSub, #footerNavCart").addClass("active");
		$("#footerSearchInner, #footerSearchLine").removeClass("active");
	});

	$("#btnSearchSp").click(function() {
		setTimeout(function() {
			$("#searchMainTxtSp").focus();
		}, 100);
		$("#closeOverlay, #searchInnerSp").toggleClass('active');
		if ($("#closeOverlay, #searchInnerSp").hasClass('active')) {
			$("#btnSearchSp").fadeOut();
			scrollpos = $(window).scrollTop();
			$("body").addClass("fixed").css({
				'top': -scrollpos
			});
			$(".bars, #searchLineSp").addClass('active');
		} else {
			$("#btnSearchSp").fadeIn();
			$("body").removeClass("fixed").css({
				'top': 0
			});
			window.scrollTo(0, scrollpos);
			$(".bars, #searchLineSp").removeClass("active");
		}
	});

	//smooth scroll
	$('#footerPageTop, #footerPageTopSp, #mainVisual a').click(function() {
		var speed = 800;
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({
			scrollTop: position
		}, speed, "easeInOutExpo");
		return false;
	});

	$(window).scroll(function() {
		if ($(this).scrollTop() > 10) {
			$("#btnPageTop").addClass("active");
		} else {
			$("#btnPageTop").removeClass("active");
		}
	});

let lastScrollTop = 0;
$(window).on("scroll", function () {
  const currentScroll = $(this).scrollTop();
  const header = $("header");
  const scrollHeight = $(document).height();
  const windowHeight = $(window).height();
  const scrollPosition = currentScroll + windowHeight;

  if (currentScroll === 0) {
    // ページトップに到達したとき
    header.removeClass("hide");
  } else if (scrollPosition >= scrollHeight - 1) {
    // 最下部に到達したとき
    header.removeClass("hide");
  } else if (currentScroll > lastScrollTop) {
    // 下方向スクロール時
    header.addClass("hide");
  } else {
    // 上方向スクロール時
    header.removeClass("hide");
  }

  lastScrollTop = currentScroll;
});

	var scrollpos;

	//btnMenu
	$('#btnMenu').click(function(){
  
		$("#closeOverlay").toggleClass('active');
      $("#shopify-section-header").toggleClass('open-menu');
		
		if ($("#closeOverlay").hasClass('active')) {
			$("#btnSearchSp").fadeOut();
			scrollpos = $(window).scrollTop();
			$("body").addClass("fixed").css({
				'top': -scrollpos
			});
			$(".bars, #navSp").addClass('active');
			setTimeout(function() {
				$("#navSpInner").addClass("active");
			}, 600);
		} else {
			$("#btnSearchSp").fadeIn();
			$("body").removeClass("fixed").css({
				'top': 0
			});
			window.scrollTo(0, scrollpos);
			$(".bars, #navSp, #navSpInner").removeClass("active");
			$("#navSpHykeInner, #navSpOnlineInner, #searchInnerSp, #searchLineSp").removeClass("active");

			//デフォルトの階層を手前に戻す
			$("#navSp > div").not(".preActive").removeClass('active');
			$("#navSp > div.preActive").addClass("active");
		}
	});

	$("#closeOverlay").click(function() {
		$("#btnSearchSp").fadeIn();
		$("#closeOverlay, .bars, #navSp, #navSpInner").removeClass("active");
		$("#navSpHykeInner, #navSpOnlineInner, #searchInnerSp, #searchLineSp").removeClass("active");
	});

	$("#navSpHyke").click(function(){
		$("#navSpHykeInner").addClass("active");
	});
  
  $("#navSpTh").click(function() {
		$("#navSpThreeInner").addClass("active");
	});
  
  $("#navSpPt").click(function() {
		$("#navSpPorterInnerPorter").addClass("active");
	});

	$("#navSpOnline").click(function() {
		$("#navSpOnlineInner").addClass("active");
	});

	$("#navSpHykeInnerHyke").click(function() {
		$("#navSpHykeInner, #navSpThreeInner, #navSpOnlineInner").removeClass("active");
	});
  
  $("#navSpThreeInnerThree").click(function() {
		$("#navSpHykeInner, #navSpThreeInner, #navSpOnlineInner").removeClass("active");
	});

	$("#navSpOnlineInnerOnline").click(function() {
		$("#navSpHykeInner, #navSpThreeInner, #navSpOnlineInner").removeClass("active");
	});

	var supportsInputAttribute = function(attr) {
		var input = document.createElement('input');
		return attr in input;
	};
	if (!supportsInputAttribute('autofocus')) {
		$('[autofocus]').focus();
	}

	//faderollover
	$.faderollover({
		in_duration: 400,
		out_duration: 400
	});

});

//faderollover
(function() {
	$.faderollover = function(option) {
		var settings = $.extend({
			target: 'img,input',
			out_suffix: '_off',
			over_suffix: '_on',
			in_duration: 500,
			out_duration: 500
		}, option);

		var objTarget = $(settings.target);
		objTarget.each(function() {

			if ($(this).attr('src') != undefined) {

				if ($(this).attr('src').match(new RegExp('.+' + settings.out_suffix + '\..+$'))) {

					this.objOverElm = $(this).clone();

					this.objOverElm.attr('src', function() {
						return $(this).attr('src').replace(settings.out_suffix, settings.over_suffix);
					});

					this.objOverElm.css({
						position: 'absolute',
						opacity: 0
					});
					$(this).before(this.objOverElm);

					$(this.objOverElm).hover(function() {
							$(this).stop().animate({
								opacity: 1
							}, {
								duration: settings.in_duration,
								queue: false
							});
						},
						function() {
							$(this).stop().animate({
								opacity: 0
							}, {
								duration: settings.out_duration,
								queue: false
							});
						});
				}
			}
		});
	}
})(jQuery);

const setInview = () => {
    const ani_objects = document.getElementsByClassName("cmn_ani_obj");
    for (var i = 0, len = ani_objects.length; i < len; i++) {
      const observer = new IntersectionObserver(
        (entries,observer) => entries.forEach(
            entry => {
                const entity = entry.target;
                if( entry.isIntersecting ){
                  entity.classList.add("view");
                }
            }
        )
      );
      observer.observe(ani_objects[i]);
    }
};

const setCover = () => {
    const ani_objects = document.getElementsByClassName("cmn_ani_cvr");
    for (var i = 0, len = ani_objects.length; i < len; i++) {
      const observer = new IntersectionObserver(
        (entries,observer) => entries.forEach(
            entry => {
                const entity = entry.target;
                if( entry.isIntersecting ){
                  entity.classList.add("view");
                }
            }
        )
      );
      observer.observe(ani_objects[i]);
    }
};

const setRiseup = () => {
  const targets = document.querySelectorAll('.cmn_ani_rup');
  targets.forEach(el => {
    const html = el.innerHTML;
    const scaleDiv = document.createElement('div');
    scaleDiv.className = 'cmn_ani_rup_scale';
    scaleDiv.innerHTML = html;
    const textDiv = document.createElement('div');
    textDiv.className = 'cmn_ani_rup_text';
    textDiv.innerHTML = html;
    el.innerHTML = '';
    el.appendChild(scaleDiv);
    el.appendChild(textDiv);
  });
};

const actRiseup = () => {
  const ani_objects = document.getElementsByClassName("cmn_ani_rup");
  for (var i = 0, len = ani_objects.length; i < len; i++) {
    const observer = new IntersectionObserver(
      (entries,observer) => entries.forEach(
          entry => {
              const entity = entry.target;
              if( entry.isIntersecting ){
                entity.classList.add("view");
              }
          }
      )
    );
    observer.observe(ani_objects[i]);
  }
};

const setPd = () => {
    const tabs = document.querySelectorAll('.global-header-pd-tab');
    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const cnt = tab.nextElementSibling;

        if (!cnt || !cnt.classList.contains('global-header-pd-cnt')) return;

        const isOpen = tab.classList.contains('open');

        if (isOpen) {
          tab.classList.remove('open');
          const height = cnt.scrollHeight;
          cnt.style.height = height + 'px';
          requestAnimationFrame(() => {
            cnt.style.height = '0px';
          });
        } else {
          tab.classList.add('open');
          cnt.style.height = 'auto';
          const height = cnt.scrollHeight;
          cnt.style.height = '0px';
          requestAnimationFrame(() => {
            cnt.style.height = height + 'px';
          });
        }

        cnt.addEventListener('transitionend', function handler(e) {
          if (!tab.classList.contains('open')) return;
          cnt.style.height = 'auto';
          cnt.removeEventListener('transitionend', handler);
        });
      });
    });  
};
